(() => {
  const storageKey = 'lifestore-recent-products-v1';
  const section = document.querySelector('[data-ls-recent]');
  const grid = document.querySelector('[data-ls-recent-grid]');
  const currentData = document.getElementById('ls-current-product');
  const stockNotice = document.querySelector('[data-ls-stock-notice]');
  const formAnchor = document.getElementById('cod-formulario');
  if (stockNotice && formAnchor) formAnchor.prepend(stockNotice);
  const mobileBuy = document.querySelector('.ls-mobile-buy');
  if (mobileBuy && formAnchor) {
    const updateMobileBuy = () => {
      const formRect = formAnchor.getBoundingClientRect();
      const overlapsViewport = formRect.top < window.innerHeight * .82 && formRect.bottom > 0;
      mobileBuy.toggleAttribute('data-form-visible', overlapsViewport);
    };
    updateMobileBuy();
    window.addEventListener('scroll', updateMobileBuy, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', updateMobileBuy, { passive: true });
    window.setTimeout(updateMobileBuy, 500);
  }
  let current;
  let history = [];
  const valid = item => item && typeof item.id === 'number' && typeof item.title === 'string' && typeof item.price === 'string' && typeof item.url === 'string' && /^\/products\/[^/?#]+$/.test(item.url);
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) history = stored.filter(valid).slice(0, 12);
    if (currentData) current = JSON.parse(currentData.textContent);
  } catch { /* Browsing tools remain optional when storage is unavailable. */ }
  const seen = new Set();
  const recommendedUrls = new Set(Array.from(document.querySelectorAll('.ls-recommended .ls-product-card__media')).map(link => new URL(link.href).pathname));
  const previous = history.filter(item => item.id !== current?.id && !recommendedUrls.has(item.url) && !seen.has(item.id) && seen.add(item.id)).slice(0, current ? 2 : 4);
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  if (section && grid && previous.length) {
    previous.forEach(item => {
      const card = el('article', 'ls-recent__card');
      const picture = el('a', 'ls-recent__picture');
      picture.href = item.url;
      picture.setAttribute('aria-label', `Ver ${item.title}`);
      try {
        const imageUrl = new URL(item.image, location.origin);
        if (item.image && ['https:', 'http:'].includes(imageUrl.protocol) && (imageUrl.origin === location.origin || imageUrl.hostname === 'cdn.shopify.com')) {
          const image = el('img');
          image.src = imageUrl.href; image.alt = item.title; image.loading = 'lazy'; image.width = 480; image.height = 480;
          picture.append(image);
        }
      } catch { /* Keep the text link when an image URL is invalid. */ }
      const body = el('div', 'ls-recent__body');
      const title = el('h3');
      const titleLink = el('a', '', item.title); titleLink.href = item.url; title.append(titleLink);
      const link = el('a', 'ls-recent__link', 'Volver a verlo →'); link.href = item.url;
      const formattedPrice = item.price.replace(/(\d),(?=\d{3}\b)/g, '$1.');
      body.append(title, el('strong', 'ls-recent__price', formattedPrice), link);
      card.append(picture, body); grid.append(card);
    });
    section.hidden = false;
  }
  if (valid(current)) {
    try { localStorage.setItem(storageKey, JSON.stringify([current, ...history.filter(item => item.id !== current.id)].slice(0, 12))); } catch { /* No effect on shopping when storage is blocked. */ }
  }
  const topButton = document.querySelector('[data-ls-back-top]');
  if (topButton) {
    const pageWrapper = document.querySelector('.page-wrapper');
    const update = () => { topButton.hidden = Math.max(window.scrollY, pageWrapper?.scrollTop || 0) < 650; };
    update(); window.addEventListener('scroll', update, { passive: true });
    pageWrapper?.addEventListener('scroll', update, { passive: true });
    topButton.addEventListener('click', () => {
      const options = { top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' };
      window.scrollTo(options);
      pageWrapper?.scrollTo(options);
    });
  }
})();
